import FetchFactory from '../factory'

interface ILogin {
  body: {
    email: string
    password: string
    remember_me: boolean
    type: string
    'g-recaptcha-response'?: string
  }
}

interface ILoginGoogle {
  body: {
    sub: string
    email: string
    name: string
    first_name: string
    last_name: string
    phone_number: string
    picture: string
    type: string
    has_experience: number | null
    'g-recaptcha-response'?: string
  }
}

interface IRegister {
  body: {
    email: string
    agree_tos: boolean
    type: string
    password: string
    password_confirmation: string
    has_experience: boolean
    first_name: string
    last_name: string
    phone_number: string
    'g-recaptcha-response'?: string
  }
}

interface IForgotPassword {
  body: {
    email: string
  }
}

interface IResetPassword {
  body: {
    token: string
    email: string
    password: string
    password_confirmation: string
  }
}

interface IVerifyEmail {
  query: {
    id: string
    hash: string
    expires: string
    signature: string
  }
}

interface IChangePassword {
  body: {
    current_password: string
    password: string
    password_confirmation: string
  }
}

class AuthModule extends FetchFactory<any> {
    async register(payload: IRegister) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/register', {
                method: 'POST',
                body
            })
        })
    }

    async login(payload: ILogin) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/login', {
                method: 'POST',
                body
            })
        })
    }

    async loginGoogle(payload: ILoginGoogle) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/login/google', {
                method: 'POST',
                body
            })
        })
    }

    async registerGoogle(payload: ILoginGoogle) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/register/google', {
                method: 'POST',
                body
            })
        })
    }

    async getProfile() {
        return await useAsyncData(() => {
            return super.call('/api/auth/me', {
                method: 'GET',
      })
        })
    }

    async logout() {
        return await useAsyncData(() => {
            return super.call('/api/auth/logout', {
                method: 'DELETE',
      })
        })
    }

    async forgotPassword(payload: IForgotPassword) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/password/forgot', {
                method: 'POST',
                body
            })
        })
    }

    async resetPassword(payload: IResetPassword) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/password/reset', {
                method: 'POST',
                body
            })
        })
    }

    async resendVerifyLink() {
        return await useAsyncData(() => {
            return super.call('/api/auth/email/resend', {
                method: 'POST',
      })
        })
    }

    async verifyEmail(payload: IVerifyEmail) {
        const { query } = payload
        return await useAsyncData(() => {
            return super.call(
                `/api/auth/email/verify/${query.id}/${query.hash}?expires=${query.expires}&signature=${query.signature}`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async updateCompleteProfile() {
        return await useAsyncData(() => {
            return super.call('/api/auth/profile/check', {
                method: 'GET',
      })
        })
    }

    async changePassword(payload: IChangePassword) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/auth/profile/change-password', {
                method: 'PATCH',
                body
            })
        })
    }
}

export default AuthModule
